import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import moment from 'moment';

import enumStringConstructor from '../../../../utils/enumStringConstructor';

import './NoticeListItem.scss';
import { useSelector } from 'react-redux';

const NoticeListItem = ({ notice }) => {
  const match = useRouteMatch('/Debts/file/:fileId/notice/:noticeId') || {
    params: {},
  };
  const {
    params: { fileId, noticeId },
  } = match;
  const noticeStates = useSelector((store) => store.debtsStore.noticeStates);
  const colorActiveBackground =
    Number(fileId) === Number(notice.fileId) &&
    Number(noticeId) === Number(notice.id)
      ? 'notice_item-container-opened'
      : '';
  const types = useMemo(() => {
    const types = [
      notice.isPhone && 'Обзвон',
      notice.isEmail && 'e-mail рассылка',
      notice.isPush && 'push уведомления',
      notice.isSms && 'SMS рассылка',
    ].filter(Boolean);
    return enumStringConstructor(types);
  }, [notice]);
  return (
    <div className={`notice_item-container ${colorActiveBackground}`}>
      <div
        key={notice.id}
        className={`notice_item ${colorActiveBackground}`}
      >
        <div className="notice_item-header">
          <span className="notice_item-title">{notice.title}</span>
          <span
            className={`info_block ${
              notice.stateId === 1 || notice.stateId === 3
                ? 'info_block-finished'
                : ''
            }`}
          >
            {noticeStates[notice.stateId]}
          </span>
        </div>
        <p className="notice_item-types">{types}</p>

        {notice.createTime && (
          <div className="createDate">
            Дата создания:{' '}
            {moment(notice.createTime).format('DD.MM.YYYY HH:mm')}
          </div>
        )}

        {notice.fromTime && (
          <div className="createDate">
            Дата отложенного запуска:{' '}
            {moment(notice.fromTime).format('DD.MM.YYYY HH:mm')}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoticeListItem;
